import BaseChart from "./BaseChart"
import ItemsHelper from '../chart_helpers/ItemsHelper'
import RootHelper from '../chart_helpers/RootHelper'
import AxisHelper from '../chart_helpers/AxisHelper'
import {continuousExtent, continuousExtentParts, cleanCollisions} from '../chart_helpers/AxisHelper'
import SelectableHelper from '../chart_helpers/SelectableHelper'
import SizeHelper from "../chart_helpers/SizeHelper"
import { PRIMARY_BIN_SCHEME } from "../utils/colorUtils"

export default class CandleStickChart extends BaseChart {
  constructor(...args) {
    super(...args)
  }
  static defaultConfig = {
    ItemsHelper:{
      colorScale: (d)=>{
        return (d.open>d.close)?PRIMARY_BIN_SCHEME[0]:PRIMARY_BIN_SCHEME[1]
      }
    },
    AxisHelper:{
      x:{
        scale: {
          value: 'linear',
          exposed: false,
        },
        
        getExtent: function (data){
          return continuousExtent(data,(d)=>d.id) //d3.extent(data.map((d)=>d.id))
        }
      },
      y:{
        getExtent: function (data){
          let extent 
          // extent = continuousExtent(data) //d3.extent(data,(d)=>d.value)
          let extentParts = continuousExtentParts(data.map((d)=>({value:[d]})),(d)=>[d.low,d.high])
          // console.log("extent parts",extentParts)
          extent = continuousExtent(extentParts) 
          if(this.config.AxisHelper.y.showTickValues && this.config.AxisHelper.y.unit){
            extent = cleanCollisions(this.axes.y, extent, extentParts)
          }
          return extent
        }
      }
    }
  }
  static helpers = [
    RootHelper,
    ItemsHelper,
    // {
    //   class: ItemsHelper,
    //   config:{
    //     colorScale: (d)=>{
    //       return (d.open>d.close)?PRIMARY_BIN_SCHEME[0]:PRIMARY_BIN_SCHEME[1]
    //     }
    //   }
    // },
    SelectableHelper,
    SizeHelper,
    AxisHelper
    // {
    //   class: AxisHelper,
    //   config: {
    //     x:{
    //       scale: 'linear',
    //       getExtent: function (data){
    //         return continuousExtent(data,(d)=>d.id) //d3.extent(data.map((d)=>d.id))
    //       }
    //     },
    //     y:{
    //       getExtent: function (data){
    //         let extent 
    //         // extent = continuousExtent(data) //d3.extent(data,(d)=>d.value)
    //         let extentParts = continuousExtentParts(data.map((d)=>({value:[d]})),(d)=>[d.low,d.high])
    //         // console.log("extent parts",extentParts)
    //         extent = continuousExtent(extentParts) 
    //         extent = cleanCollisions(this.axes.y, extent, extentParts)
    //         return extent
    //       }
    //     }
    //   }
    // },
    
  ]
  checkConsistency(){
    return true
  }
  draw () {
   
    let enter = this.itemsEnter.selectAll('.candle').data([null]).enter().append('g').attr('class','candle')
    enter.append('rect')
    enter.append('line')
    this.itemsEnter.select('.candle')
      .attr('transform',(d)=>`translate(${this.axes.x.func.scale()(d.id)},${this.axes.y.func.scale()(d.high)})`)
    
    this.itemsEnterTrans.select('.candle').select('rect')
      .attr('fill',(d)=>this.color(d))
      .attr('width',10)
      .attr('x',-5)
      .attr('y',(d)=>this.axes.y.func.scale()(d.open)-this.axes.y.func.scale()(d.high))
      .attr('height',(d)=>Math.abs(this.axes.y.func.scale()(d.open)-this.axes.y.func.scale()(d.close)))
    
    this.itemsEnterTrans.select('.candle').select('line')
      .attr('stroke',(d)=>this.color(d))
      .attr('y0',()=>0)
      .attr('y1',(d)=>this.axes.y.func.scale()(d.low)-this.axes.y.func.scale()(d.high))
    
    this.itemsTrans.select('.candle')
      .attr('transform',(d)=>`translate(${this.axes.x.func.scale()(d.id)},${this.axes.y.func.scale()(d.high)})`)
    
    this.itemsTrans.select('.candle').select('rect')
      .attr('fill',(d)=>this.color(d))
      .attr('width',10)
      .attr('x',-5)
      .attr('y',(d)=>this.axes.y.func.scale()(d.open)-this.axes.y.func.scale()(d.high))
      .attr('height',(d)=>Math.abs(this.axes.y.func.scale()(d.open)-this.axes.y.func.scale()(d.close)))
    
    this.itemsTrans.select('.candle').select('line')
      .attr('stroke',(d)=>this.color(d))
      .attr('y0',()=>0)
      .attr('y1',(d)=>this.axes.y.func.scale()(d.low)-this.axes.y.func.scale()(d.high))
      
    this.itemsExitTrans.style('opacity',0)
  }
  
}
